// Libraries
// Components
import { FilterFactory, FilterGroupsType, FilterVariant, TableFiltersDisplayProps } from '@organisms/index';
// Types
import { Fragment } from 'react';
import { TableFiltersRatings } from '../TableFiltersRatings';

/**
 * Display the visible table filters based on the provided filter options map and column objects.
 *
 * @component
 * @template TableBody - The type of the table body.
 * @template ColumnNames - The type of the column names.
 * @param {TableFiltersDisplayProps<TableBody, ColumnNames>} props - The component props containing filter options map and column objects.
 * @param {FilterOptionsMap<ColumnNames>} props.filterOptionsMap - Map of filter options for each column.
 * @param {ColumnsObject<TableBody>} props.columnsObj - Object representing the columns of the table.
 * @param {boolean} props.smallerViews - Flag to determine if the filters are going to be displayed in smaller views.
 * @returns {ReactElement} Component with the visible table filters.
 */
export const TableFiltersVisible = <TableBody, ColumnNames extends string>({
  filterOptionsMap,
  columnsGroup,
  smallerViews,
}: TableFiltersDisplayProps<TableBody, ColumnNames>) => {
  return (
    <Fragment>
      {Object.keys(columnsGroup).map((groupKey) => {
        if (groupKey === FilterGroupsType.CII_RATING) {
          return (
            <TableFiltersRatings
              key='cii_ratings_filter_container'
              filterOptionsMap={filterOptionsMap}
              ciiColumns={columnsGroup[groupKey]}
              variant={FilterVariant.VISIBLE}
            />
          );
        }
        return columnsGroup[groupKey].map((column) => {
          return column.getCanFilter && column.getCanFilter() ? (
            <FilterFactory<TableBody, ColumnNames>
              column={column}
              columnId={column.id}
              filterOptionsMap={filterOptionsMap}
              key={`${column.id}_filter`}
              variant={FilterVariant.VISIBLE}
              smallerViews={smallerViews}
            />
          ) : null;
        });
      })}
    </Fragment>
  );
};
